"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var core_1 = require("@material-ui/core");
var DotMenu_1 = __importDefault(require("./icons/DotMenu"));
var icons_1 = require("@material-ui/icons");
var hoveredIconButtonStyles_1 = require("./hoveredIconButtonStyles");
var react_intl_1 = require("react-intl");
var popupPositionProps = {
    anchorOrigin: {
        vertical: 'bottom',
        horizontal: 'left',
    },
    transformOrigin: {
        vertical: 'top',
        horizontal: 'left',
    },
};
function TTableColumnMenu(props) {
    var col = props.col, cellRef = props.cellRef, isHovered = props.isHovered, changeVisibleColumns = props.changeVisibleColumns;
    var _a = hoveredIconButtonStyles_1.useHoveredIconButtonStyles(), root = _a.root, icon = _a.icon, active = _a.active, hovered = _a.hovered;
    var _b = react_1.default.useState(null), anchorMenu = _b[0], setAnchorMenu = _b[1];
    var openMenu = Boolean(anchorMenu);
    var handleClickMenu = react_1.useCallback(function (event) {
        setAnchorMenu(event.currentTarget);
    }, [setAnchorMenu]);
    var handleCloseMenu = react_1.useCallback(function () {
        setAnchorMenu(null);
    }, [setAnchorMenu]);
    var _c = react_1.default.useState(null), anchorFilter = _c[0], setAnchorFilter = _c[1];
    var openFilter = react_1.useMemo(function () { return Boolean(anchorFilter); }, [anchorFilter]);
    var handleClickFilter = react_1.useCallback(function () {
        setAnchorFilter(cellRef);
        handleCloseMenu();
    }, [setAnchorFilter, handleCloseMenu, cellRef]);
    var handleCloseFilter = react_1.useCallback(function () {
        setAnchorFilter(null);
    }, [setAnchorFilter]);
    var hideCol = react_1.useCallback(function () {
        changeVisibleColumns(col.columnCode);
    }, [changeVisibleColumns, col]);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        col.filterValue ? (react_1.default.createElement(core_1.Grid, { item: true },
            react_1.default.createElement(core_1.ButtonBase, { component: "span", disableRipple: true, className: root + " " + active, onClick: handleClickFilter },
                react_1.default.createElement(icons_1.FilterList, { className: icon })))) : null,
        react_1.default.createElement(core_1.Grid, { item: true },
            react_1.default.createElement(core_1.ButtonBase, { disableRipple: true, className: root + " " + (openMenu || openFilter ? active : '') + " " + (isHovered ? hovered : ''), onClick: handleClickMenu },
                react_1.default.createElement(DotMenu_1.default, { className: icon }))),
        react_1.default.createElement(core_1.Menu, __assign({ id: "column-menu", anchorEl: anchorMenu, variant: "menu", getContentAnchorEl: null, open: openMenu, onClose: handleCloseMenu }, popupPositionProps),
            col.canFilter ? (react_1.default.createElement(core_1.MenuItem, { onClick: handleClickFilter },
                react_1.default.createElement(react_intl_1.FormattedMessage, { id: "ttable.filter", defaultMessage: "\u0424\u0438\u043B\u044C\u0442\u0440" }))) : null,
            col.blockHide ? null : (react_1.default.createElement(core_1.MenuItem, { onClick: hideCol },
                react_1.default.createElement(react_intl_1.FormattedMessage, { id: "ttable.hideColumn", defaultMessage: "\u0421\u043A\u0440\u044B\u0442\u044C \u0441\u0442\u043E\u043B\u0431\u0435\u0446" })))),
        col.canFilter ? (react_1.default.createElement(core_1.Popover, __assign({ open: openFilter, anchorEl: anchorFilter, onClose: handleCloseFilter }, popupPositionProps),
            react_1.default.createElement(core_1.Paper, null,
                react_1.default.createElement(core_1.Box, { width: 350, padding: 3 }, col.render('Filter'))))) : null));
}
exports.default = TTableColumnMenu;
